var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1193,
    height: 921,
    viewBox: "0 0 1193 921",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_957_523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 68,
    width: 1096,
    height: 720
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.706 758.42L336.958 658.336C514.257 540.164 748.524 544.552 921.445 668.935C1004.56 728.797 1067.89 774.3 1067.89 774.3C1127.82 817.819 1206.25 744.766 1163.69 683.976L788.382 145.67C756.797 98.587 704.907 73.2217 651.556 69.5374C590.279 63.9002 527.72 88.2863 488.703 140.236L94.0744 664.537C49.6077 723.113 124.371 799.848 186.513 758.273L186.706 758.42Z",
    fill: "url(#paint0_linear_957_523)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_957_523)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_957_523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.426,
    cy: 42.1352,
    rx: 186.778,
    ry: 168.528,
    transform: "rotate(0.651227 544.426 42.1352)",
    fill: "#2B7EDE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_957_523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.724,
    cy: 449.688,
    rx: 164.71,
    ry: 148.616,
    transform: "rotate(0.651227 724.724 449.688)",
    fill: "#2B7EDE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_957_523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.653,
    cy: 328.324,
    rx: 261.892,
    ry: 244.17,
    transform: "rotate(0.651227 349.653 328.324)",
    fill: "#FF9D9D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_f_957_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.483 373.022C477.559 454.32 341.603 555.831 253.632 554.831C165.661 553.831 95.0951 487.116 96.0192 405.819C96.9433 324.521 169.007 259.427 256.978 260.427C335.93 437.023 479.407 291.725 478.483 373.022Z",
    fill: "#F578E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_f_957_523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 885.895,
    cy: 398.334,
    rx: 114.873,
    ry: 106.158,
    transform: "rotate(0.651227 885.895 398.334)",
    fill: "#FCE3B3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_f_957_523)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 766.88,
    cy: 182.715,
    rx: 245.692,
    ry: 220.463,
    transform: "rotate(0.651227 766.88 182.715)",
    fill: "#BCAAF1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_957_523",
    x: 107.649,
    y: -376.396,
    width: 873.553,
    height: 837.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_957_523",
    x: 310.016,
    y: 51.0694,
    width: 829.417,
    height: 797.237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_957_523",
    x: -162.236,
    y: -165.849,
    width: 1023.78,
    height: 988.346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_957_523",
    x: -153.99,
    y: 10.4153,
    width: 882.477,
    height: 794.423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_957_523",
    x: 521.023,
    y: 42.1739,
    width: 729.743,
    height: 712.319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_957_523",
    x: 271.19,
    y: -287.753,
    width: 991.379,
    height: 940.934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_957_523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_523",
    x1: 180.582,
    y1: 402.513,
    x2: 1142.68,
    y2: 484.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BCBF6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgPattern);
export default __webpack_public_path__ + "static/media/hero-bg-pattern.6a44e9fd8d8fe8447c13f99a39537f65.svg";
export { ForwardRef as ReactComponent };